import React, { useState } from 'react';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200 py-3 sm:py-4"> {/* Changed: Less padding on mobile */}
      <button 
        className="flex justify-between items-center w-full text-left"
        onClick={() => setIsOpen(!isOpen)}
      >
        {/* Question - Responsive text size */}
        <h3 className="text-base sm:text-lg font-medium text-gray-900 pr-4">
          {question}
        </h3>
        
        {/* Arrow icon - Smaller on mobile */}
        <svg 
          className={`w-5 h-5 sm:w-6 sm:h-6 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {/* Answer - Responsive padding and text */}
      {isOpen && (
        <div className="mt-2 sm:mt-3 text-gray-600 text-sm sm:text-base pl-0 sm:pl-0">
          <p className="leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
};

export default FAQItem;